import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AppConfigProvider } from './utils/AppConfigContext';
import { AuthProvider, AuthRequired } from './utils/AuthContext';
import { LanguageProvider } from './utils/LanguageContext';
import AppFooter from './components/Footer';
import Navbar from './components/Navbar';
import AccountPage from './pages/AccountPage';
import AdminAccountPage from './pages/AdminAccountPage';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import { App, ConfigProvider, Layout } from 'antd';
import OnboardingForm from './components/OnboardingForm';
import AdminOnboardingForm from './components/AdminOnboardingForm';
import EmailForPasswordResetForm from './components/EmailForPasswordResetForm';
import PasswordResetForm from './components/PasswordResetForm';
import EmailUpdateHandler from './components/EmailUpdateHandler';
import SignupForm from './components/SignupForm';
import VerifyEmailForm from './components/VerifyEmailForm';
import Blog from './pages/Blog';
import AdminHomePage from './pages/AdminHomePage';
import AboutUs from './pages/AboutUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ContactUs from './pages/ContactUs';
import { Content, Footer, Header } from 'antd/es/layout/layout';
import { Colors } from './Colors';
import './App.css';
import MarketingLeadForm from './components/MarketingLeadForm';

function CrecerApp() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorBgHeader: Colors.darkGreen,
          colorPrimary: Colors.mediumGreen,
          colorBgContainer: Colors.lightGray,
          colorBgBase: Colors.white,
          colorBgLayout: Colors.white,
        },
      }}
    >
      <App>
        <AppConfigProvider>
          <LanguageProvider>
            <Router>
              <AuthProvider>
                <Layout className="app-layout">
                  <Header className="app-header">
                    <Navbar />
                  </Header>
                  <Content className="app-content">
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/login" element={<LoginPage />} />
                      <Route path="/signup" element={<SignupForm />} />
                      <Route path="/signupWithEmployer/:activationCode" element={<SignupForm />} />
                      <Route path="/verifyEmail" element={<VerifyEmailForm />} />
                      <Route path="/forgotPassword" element={<EmailForPasswordResetForm />} />
                      <Route path="/resetPassword" element={<PasswordResetForm />} />
                      <Route path="/blog" element={<Blog />} />
                      <Route path="/admin" element={<AdminHomePage />} />
                      <Route path="/about" element={<AboutUs />} />
                      <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                      <Route path="/termsofservice" element={<TermsOfService />} />
                      <Route path="/contact" element={<ContactUs />} />
                      <Route path="/register" element={<MarketingLeadForm />} />
                      <Route
                        path="/account"
                        element={
                          <AuthRequired>
                            <AccountPage />
                          </AuthRequired>
                        }
                      />
                      <Route
                        path="/updateEmail"
                        element={
                          <AuthRequired>
                            <EmailUpdateHandler />
                          </AuthRequired>
                        }
                      />
                      <Route
                        path="/onboarding"
                        element={
                          <AuthRequired>
                            <OnboardingForm />
                          </AuthRequired>
                        }
                      />
                      <Route
                        path="/onboarding/:activationCode"
                        element={
                          <AuthRequired>
                            <OnboardingForm />
                          </AuthRequired>
                        }
                      />
                      <Route path="/admin/signup" element={<SignupForm isPayrollAdmin={true} />} />
                      <Route path="/admin/onboarding" element={<AdminOnboardingForm />} />
                      <Route
                        path="/admin/dashboard"
                        element={
                          <AuthRequired>
                            <AdminAccountPage />
                          </AuthRequired>
                        }
                      />
                    </Routes>
                  </Content>
                  <Footer className="app-footer">
                    <AppFooter />
                  </Footer>
                </Layout>
              </AuthProvider>
            </Router>
          </LanguageProvider>
        </AppConfigProvider>
      </App>
    </ConfigProvider>
  );
}

// TODO implement https://www.fullstory.com/ (backup: https://sentry.io/welcome/ )

export default CrecerApp;
